module.exports = __webpack_public_path__ + "static/hymots-yatay2-5ec91e428f56654f4d1c90f2e6b56ed4.png";